<template>
    <div class="row panel-body">
        <form method="post" ref="form">
            <input type="hidden" name="_token" :value="csrfToken" />


            <div class="subtitle-localization-cue text-primary">
                <div class="row">
                    <h2 class="col-xs-1" style="white-space:nowrap;">
                        Title
                        <i
                                style="margin-left: 5px;"
                                class="fa fa-eye tool_tip"
                                :title="title"
                                data-toggle="tooltip">

                        </i>
                    </h2>

                    <div class="col-xs-6">
                        <div :class="{ 'has-error': newTitle.trim() === '' }">
                            <h2>
                                <input class="form-control"
                                       style="color:black"
                                       type="text"
                                       @keyup="setCanSubmit()"
                                       placeholder="Translated Lesson Title"
                                       name="lesson_title"
                                       :required="true"
                                       v-model="newTitle"
                                       id="lesson-title-translation" />
                            </h2>

                            <span class="help-block" v-if="newTitle.trim() === ''">
                            The title cannot be empty!
                        </span>

                        </div>
                    </div>
                </div>
            </div>
            <div class="row">&nbsp;</div>
            <div class="row">
                <div class="col-xs-offset-1 col-xs-11">
                    <div class="row">
                        <div class="col-xs-12">
                            <h4>Localization</h4>
                        </div>
                    </div>
                </div>
            </div>
            <subtitle-localization-cue
                    v-for="(cue, number) in masterCues"
                    :number="number"
                    :key="number"
                    :work-in-progress-lines="workInProgressCues[number]">
            </subtitle-localization-cue>

            <div class="row">
                <div class="col-xs-5">
                  <div class="row">
                    <div class="col p-2">
                      <div class="form-check">
                        <input
                            type="checkbox"
                            v-model="noLocalizationRequired"
                            @click="noLocalizationRequired = !noLocalizationRequired"
                            name="noLocalizationRequired"
                            id="noLocalizationRequired"
                            v-bind:value="noLocalizationRequired"
                        />
                        <label class="form-check-label" for="noLocalizationRequired">
                          <h5>
                            NO VOICE LOCALIZATION REQUIRED
                            <i
                                style="margin-left: 5px;"
                                class="fa fa-info-circle tool_tip"
                                title='In some cases, you might be requesting changes to the subtitle text that will NOT require voice changes. (Examples: "July" to "july", "98%" to "98 %" or "4 x 2 = 8" to "4 · 2 = 8".) In these cases, please select the "NO VOICE LOCALIZATION REQUIRED" option.'
                                data-toggle="tooltip"
                            >
                            </i>
                          </h5>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-3 pl-5">
                    <button class="btn btn-default"
                            name="submit-save"
                            @click.prevent="save('Saved')">
                        <strong>Save</strong>
                    </button>
                  </div>
                </div>

                <div class="col-xs-5 col-xs-offset-2 text-right">
                    <submit-button></submit-button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    let toastr = require('toastr')

    export default {
        props: [
            'masterCuesJson',
            'workInProgressJson',
            'saveRoute',
            'title',
        ],

        data: function() {
            return {
                csrfToken: window.csrfToken,
                newTitle: this.title,
                autosaveCache: '',
                noLocalizationRequired: false,
            }
        },

        computed: {
            masterCues: function() {
                return JSON.parse(this.masterCuesJson)
            },
            workInProgressCues: function() {
                return JSON.parse(this.workInProgressJson)
            },
            comments: function() {
                return JSON.parse(this.commentsJson)
            },
            timestamps: function() {
                return JSON.parse(this.timestampsJson)
            },
        },

        mounted() {
            this.autosaveCache = $(this.$refs.form).serialize();
            this.autosaveTimer()
        },

        methods: {
            autosaveTimer() {
                setTimeout(() => {
                    this.autosave()
                    this.autosaveTimer()
                }, 60000) // once per minute
            },

            autosave() {
                // only autosave if form data has changed since last save
                if (this.autosaveCache !== $(this.$refs.form).serialize()) {
                    this.save('Auto saved');
                }
            },

            save(message) {
                let formData = $(this.$refs.form).serialize()

                window.axios.post(this.saveRoute, formData).then(() => {
                    this.autosaveCache = formData;
                    toastr.success(message)
                }).catch(() => {
                    toastr.error('Something went wrong...', message)
                })
            },
        },
    }
</script>
